import { KeycloakLoginOptions } from 'keycloak-js';

/**
 * Langue courante de l'application, telle que la stocke `LanguageService`.
 *
 * <p>Fonction libre et non un service : elle est appelée depuis des gardes et
 * un intercepteur, où injecter `LanguageService` créerait des dépendances
 * circulaires pour lire une seule clé de `localStorage`.</p>
 */
const LANG_KEY = 'lang';
const DEFAULT_LANG = 'ar';

/**
 * Complète des options de connexion Keycloak avec la langue courante.
 *
 * <p><b>Le problème résolu.</b> Les écrans de connexion ne sont pas rendus par
 * Angular : Keycloak les sert lui-même, avant que l'application n'existe. Il
 * choisit sa langue d'après le paramètre `ui_locales`, puis le cookie
 * `KEYCLOAK_LOCALE`, puis `Accept-Language`. Or ce cookie appartient au domaine
 * `auth.skill2era.com` et l'application vit sur `app.skill2era.com` : elle ne
 * peut pas l'écrire. Sans `ui_locales`, un élève qui a mis l'interface en arabe
 * arrive donc sur une page de connexion dans la langue du navigateur — souvent
 * le français, parfois l'anglais.</p>
 *
 * <p>`keycloak-js` n'applique `initOptions.locale` qu'au parcours automatique
 * de `onLoad: 'login-required'` (voir `keycloak.js`, fonction `onLoad`). Toutes
 * les redirections déclenchées à la main doivent donc porter l'option
 * elles-mêmes — d'où cette fonction, appelée sur chaque `login()`.</p>
 *
 * <p>Une locale explicitement passée par l'appelant est conservée : c'est ce
 * qui permettra, le jour venu, d'envoyer un lien de connexion dans une langue
 * imposée.</p>
 */
export function withCurrentLocale(
  options: KeycloakLoginOptions = {}
): KeycloakLoginOptions {
  return { ...options, locale: options.locale ?? currentLang() };
}

/** Langue retenue par l'utilisateur, arabe par défaut — comme le reste du produit. */
export function currentLang(): string {
  return localStorage.getItem(LANG_KEY) || DEFAULT_LANG;
}
